var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,11H5.8c-0.3,0-0.5-0.2-0.5-0.5V5.8c0-0.3,0.2-0.5,0.5-0.5h4.8c0.3,0,0.5,0.2,0.5,0.5v4.8C11,10.8,10.8,11,10.5,11z  M6.3,10H10V6.3H6.3V10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.2,11h-4.8c-0.3,0-0.5-0.2-0.5-0.5V5.8c0-0.3,0.2-0.5,0.5-0.5h4.8c0.3,0,0.5,0.2,0.5,0.5v4.8 C18.7,10.8,18.5,11,18.2,11z M14,10h3.8V6.3H14V10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,18.7H5.8c-0.3,0-0.5-0.2-0.5-0.5v-4.8c0-0.3,0.2-0.5,0.5-0.5h4.8c0.3,0,0.5,0.2,0.5,0.5v4.8 C11,18.5,10.8,18.7,10.5,18.7z M6.3,17.7H10V14H6.3V17.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.2,18.7h-4.8c-0.3,0-0.5-0.2-0.5-0.5v-4.8c0-0.3,0.2-0.5,0.5-0.5h4.8c0.3,0,0.5,0.2,0.5,0.5v4.8 C18.7,18.5,18.5,18.7,18.2,18.7z M14,17.7h3.8V14H14V17.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,9C2.7,9,2.5,8.8,2.5,8.5V6.2c0-2,1.6-3.7,3.7-3.7h2.3C8.8,2.5,9,2.7,9,3S8.8,3.5,8.5,3.5H6.2c-1.5,0-2.7,1.2-2.7,2.7 v2.3C3.5,8.8,3.3,9,3,9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,9c-0.3,0-0.5-0.2-0.5-0.5V6.2c0-1.5-1.2-2.7-2.7-2.7h-2.3C15.2,3.5,15,3.3,15,3s0.2-0.5,0.5-0.5h2.3 c2,0,3.7,1.6,3.7,3.7v2.3C21.5,8.8,21.3,9,21,9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.8,21.5h-2.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.3c1.5,0,2.7-1.2,2.7-2.7v-2.3c0-0.3,0.2-0.5,0.5-0.5 s0.5,0.2,0.5,0.5v2.3C21.5,19.8,19.8,21.5,17.8,21.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,21.5H6.2c-2,0-3.7-1.7-3.7-3.7v-2.3C2.5,15.2,2.7,15,3,15s0.5,0.2,0.5,0.5v2.3c0,1.5,1.2,2.7,2.7,2.7h2.3 C8.8,20.5,9,20.7,9,21S8.8,21.5,8.5,21.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.5,7.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrCode);
export default __webpack_public_path__ + "static/media/icon-qr-code.c0f9cebeb7fb8579230088ff3b26cd51.svg";
export { ForwardRef as ReactComponent };